import { createPageApp } from '@/lib/createPageApp'
import EventsIndexPage from './EventsIndexPage.vue'

createPageApp(EventsIndexPage).mount()
